//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQRowCard from "@/components/Generics/AQRowCard/AQRowCard.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    components: {
        AQChip,
        AQRowCard,
        AQModal,
        AQCard
    },
    props: {
        selectedActivity: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    data() {
        return {
            localRule: null,
            showApprovalModal: false,
            ruleToImport: {},
            selectedRule: null,
            importSelectedConditions: true,
            hasSave: { label: this.$t("generic.add") }
        };
    },
    computed: {
        filtredConditions() {
            let conditions = [];
            if (
                this.selectedActivity
                && Object.entries(this.selectedActivity).length
            ) {
                if (this.selectedActivity.pluginType) {
                    if (this.selectedActivity.pluginType === "TASK_PLUGIN") {
                        conditions = this.selectedActivity.rules;
                    } else if (
                        this.selectedActivity.pluginType === "API_PLUGIN"
                    ) {
                        const apiRules = [];
                        this.selectedActivity.apiConfigure.responses.forEach(
                            rule => {
                                if (rule.rule) {
                                    apiRules.push(rule.rule);
                                }
                            }
                        );
                        conditions = apiRules;
                    } else if (
                        this.selectedActivity.pluginType === "BLOCKCHAIN_EVENT_PLUGIN" || this.selectedActivity.pluginType === "START_BLOCKCHAIN_EVENT_PLUGIN"
                    ) {
                        conditions = this.selectedActivity.blockchainEvent.rules;
                    } else if (
                        this.selectedActivity.pluginType === "EXPOSE_API_PLUGIN"
                    ) {
                        conditions = this.selectedActivity.apiConfigure.validationRules.concat(
                            this.selectedActivity.apiConfigure.actionRules
                        );
                    } else if (
                        this.selectedActivity.pluginType
                        === "EXTERNAL_SOURCE_PLUGIN"
                    ) {
                        conditions = this.selectedActivity.rules;
                    }
                } else if (this.selectedActivity.notificationRules) {
                    conditions = this.selectedActivity.notificationRules;
                }
            }
            return conditions;
        }
    },
    watch: {
        selectedActivity: {
            handler() {
                this.showApprovalModal = this.selectedActivity.pluginType
                    && this.selectedActivity.pluginType === "APPROVAL_PLUGIN";
            },
            immediate: true
        }
    },
    methods: {
        actionsDlg(event) {
            if (event === "close") {
                this.$emit("input", false);
            } else if (event === "primary") {
                this.$emit("input", false);
                this.$emit("importSelectedRule", this.ruleToImport);
            }
        },
        conditionsNumber(rule) {
            let conditionNr = "";
            if (rule.conditions.conditions.length) {
                const conditionLength = rule.conditions.conditions.length;
                conditionNr = `${conditionLength} ${this.$t(
                    `diagrams.components.importConditions.${
                        conditionLength > 1 ? "conditions" : "condition"}`
                )}`;
            }
            return conditionNr;
        },

        selectedRuleToImport(rule) {
            this.localRule = rule;
            this.ruleToImport = rule;
        }
    }
};
